/** 表格列显示、多选与批量删除（与 gasCrudPage 配合） */

import {
  loadColumnVisibility,
  saveColumnVisibility,
  resolveColumnStorageKey
} from '@/utils/tableColumnStorage'

export default {
  data() {
    return {
      selectedIds: [],
      tableColumnDefs: [],
      tableColumnVisible: {},
      _tableColumnStorageKey: '',
      _tableColumnPersistReady: false
    }
  },
  computed: {
    tableCanBatchDelete() {
      return !!(this.batchRemoveApi || this.removeApi)
    }
  },
  watch: {
    tableColumnVisible: {
      deep: true,
      handler(val) {
        if (!this._tableColumnPersistReady || !this._tableColumnStorageKey) return
        if (!val || !Object.keys(val).length) return
        saveColumnVisibility(this._tableColumnStorageKey, val)
      }
    }
  },
  methods: {
    initTableColumns(defs, storageKey) {
      this._tableColumnPersistReady = false
      this.tableColumnDefs = defs || []
      this._tableColumnStorageKey = resolveColumnStorageKey(this.$route, storageKey || this.tableColumnStorageKey)

      const defaults = {}
      this.tableColumnDefs.forEach(d => {
        defaults[d.key] = d.visible !== false
      })

      const saved = loadColumnVisibility(this._tableColumnStorageKey)
      if (saved) {
        const merged = { ...defaults }
        this.tableColumnDefs.forEach(d => {
          if (Object.prototype.hasOwnProperty.call(saved, d.key)) {
            merged[d.key] = saved[d.key] !== false
          }
        })
        const visibleCount = Object.values(merged).filter(v => v !== false).length
        this.tableColumnVisible = visibleCount > 0 ? merged : defaults
      } else {
        this.tableColumnVisible = defaults
      }

      this.$nextTick(() => {
        this._tableColumnPersistReady = true
      })
    },
    colVisible(key) {
      if (!this.tableColumnDefs.length) return true
      if (!this.tableColumnVisible || !Object.keys(this.tableColumnVisible).length) return true
      return this.tableColumnVisible[key] !== false
    },
    handleSelectionChange(rows) {
      const field = this.idField || 'id'
      this.selectedIds = (rows || []).map(r => r[field])
    },
    buildBatchRemovePayload() {
      if (typeof this.batchRemovePayload === 'function') {
        return this.batchRemovePayload(this.selectedIds)
      }
      if (this.batchRemoveIdsWrapper === 'iot') {
        return { ids: this.selectedIds }
      }
      return { ids: this.selectedIds }
    },
    async batchRemove(confirmMessage) {
      if (!this.selectedIds.length) {
        return this.$message.warning('请先勾选要删除的记录')
      }
      if (!this.batchRemoveApi && !this.removeApi) {
        return this.$message.warning('当前页面不支持批量删除')
      }
      await this.$confirm(confirmMessage || '确认批量删除所选记录？', '提示', { type: 'warning' })
      if (this.batchRemoveApi) {
        const payload = this.buildBatchRemovePayload()
        if (this.batchRemoveIdsWrapper === 'iot') {
          await this.batchRemoveApi(payload.ids || this.selectedIds)
        } else {
          await this.batchRemoveApi(payload)
        }
      } else {
        for (const id of this.selectedIds) {
          await this.removeApi(id)
        }
      }
      this.$message.success('删除成功')
      this.selectedIds = []
      if (this.loadData) this.loadData()
      if (this.afterBatchRemove) this.afterBatchRemove()
    }
  }
}
